<script setup>
import { ref, computed, watchEffect } from 'vue';
import { GoogleMap, Marker } from "vue3-google-map";

const props = defineProps({
  locations: {
    default: []
  }
});

const mapOpen = ref(false);

const GoogleMapAPIKey = computed(() => window.Laravel.gmapApiKey);

const mapRef = ref(null);
const zoom = ref(5); // default
const center = ref({
  lat: 48.8538302,
  lng: 2.2982161
});
// watch of locations props to update the map zoom and center when locations change
watchEffect(() => {
  console.log('watch locations', props.locations.length, mapRef.value?.ready)
  if (props.locations.length > 0 && mapRef.value?.ready) {
    const gmap = mapRef.value.map;
    const api = mapRef.value.api;

    const bounds =  new api.LatLngBounds();
    props.locations.forEach((location) => {
      bounds.extend(new api.LatLng(location.latitude, location.longitude));
    });

    gmap.fitBounds(bounds);
    const centerForLocations = bounds.getCenter();

    center.value = {
      lat: centerForLocations.lat(),
      lng: centerForLocations.lng()
    };

    let level = gmap.getZoom();
    console.log('level', level);
    if ( level > 12 ) {
      level = 12;
    }
    console.log('setZoom ', level);
    gmap.setZoom(level);
    zoom.value = level;
  }
});

const emit = defineEmits(['selectLocation']);
const selectLocation = (l) => {
  console.log('select location', l);
  emit('selectLocation', l);
};
</script>

<template>
    <div class="position-relative mb-5">
        <GoogleMap
          ref="mapRef"
          :api-key="GoogleMapAPIKey"
          :center="center"
          :zoom="zoom"
          :max-zoom="18"
          :style="{ width: '100%', height: mapOpen ? '600px' : '300px', display: 'block', transition: 'height 1s', }">

          <Marker v-for="location in locations"
                  :key="location.id"
                  :options="{
                      position: {
                            lat: location.latitude,
                            lng: location.longitude,
                      },
                      clickable: true,
                  }"
                  @click="selectLocation(location)"
          />
        </GoogleMap>
        <a href v-on:click.prevent="mapOpen = !mapOpen" class="text-reset text-decoration-none py-1 px-2 rounded-lg shadow-sm bg-light position-absolute mx-auto " style="left: 50%; bottom: -55px; transform: translate(-50%, -50%);">
          <small class="d-flex align-items-center justify-content-start">
            <i class="fa fa-angle-down" :class="mapOpen ? 'fa-rotate-180' : ''"></i>
            <span class="ml-2">
            {{ mapOpen ? $t('Reduce map') : $t('Enlarge map') }}
          </span>
          </small>
        </a>
    </div>
</template>